import {
  FETCH_CRISIS,
  FETCH_CRISIS_SUCCESS,
  FETCH_CRISIS_ERROR,
  LOAD_MORE_CRISIS,
  LOAD_MORE_CRISIS_SUCCESS,
  LOAD_MORE_CRISIS_ERROR,
  ADD_CRISIS,
  ADD_CRISIS_SUCCESS,
  ADD_CRISIS_ERROR,
  RESET_ADD_CRISIS,
} from "constants/ActionTypes";

export const fetchCrisis = (params) => {
  return {
    type: FETCH_CRISIS,
    params,
  }
};

export const fetchCrisisSuccess = (CrisisList) => {
  return {
    type: FETCH_CRISIS_SUCCESS,
    payload: CrisisList,
  }
};

export const fetchCrisisError = (error) => {
  return {
    type: FETCH_CRISIS_ERROR,
    payload: error
  }
};

export const loadMoreCrisis = (params) => {
  return {
    type: LOAD_MORE_CRISIS,
    params,
  }
};

export const loadMoreCrisisSuccess = (CrisisList) => {
  return {
    type: LOAD_MORE_CRISIS_SUCCESS,
    payload: CrisisList,
  }
};

export const loadMoreCrisisError = (error) => {
  return {
    type: LOAD_MORE_CRISIS_ERROR,
    payload: error
  }
};


export const addCrisis = (payload) => {
  return {
    type: ADD_CRISIS,
    payload,
  }
};

export const addCrisisSuccess = (payload) => {
  return {
    type: ADD_CRISIS_SUCCESS,
    payload,
  }
};

export const addCrisisError = (error) => {
  return {
    type: ADD_CRISIS_ERROR,
    payload: error
  }
};

export const resetAddCrisis = () => {
  return {
    type: RESET_ADD_CRISIS,
  }
};
